export const ORG_OWNER_SORTS = [
  {
    key: "name_asc",
    label: "Name, A-Z"
  },
  {
    key: "name_desc",
    label: "Name, Z-A"
  },
  {
    key: "created_at_desc",
    label: "Invited At, Newest First"
  },
  {
    key: "created_at_asc",
    label: "Invited At, Oldest First"
  }
] as const;

export type OrgOwnerSort = (typeof ORG_OWNER_SORTS)[number]["key"];
